const LATORI_BG_COLORS = {
  'latori-color-green-light': 'bg-latori-green-light',
  'latori-color-green': 'bg-latori-green',
  'latori-color-green-dark': 'bg-latori-green-dark',
  'latori-color-pink': 'bg-latori-pink',
  'latori-color-gray': 'bg-latori-gray',
  'latori-color-light': 'bg-background-light',
};
export default LATORI_BG_COLORS;
